<template>
  <div
    class="inner-header"
    :class="{ 'inner-header-small': small, 'inner-header-fixed': fixed, 'inner-header-fixed-only' : fixedOnly }"
  >
    <div
      class="inner-header-nav-wrapper"
      :class="{ 'inner-header-nav-wrapper-small': small, 'inner-header-nav-wrapper-fixed': fixed }"
    >
      <transition name="slide-fade-top" mode="out-in">
        <Header v-if="!fixed"/>
        <span v-else class="kcm text-light scroll-top" @click="toggleScroll()">
          <span v-if="fixedOnly">J</span>
          <span v-else>A</span>
        </span>
      </transition>
      <transition name="slide-fade-top" mode="out-in">
        <span v-if="!fixed" class="empty-span"></span>
        <img
          v-else
          @click="goToHome()"
          class="logo-small"
          src="../../assets/img/logo_small.svg"
          alt="KCM"
        >
      </transition>
      <div class="inner-header-nav-bg" :style="{ backgroundColor: bgColor }"></div>
      <div
        class="inner-header-nav-img"
        :style="{ backgroundImage: `url(${cover})`, backgroundPosition: `${bgPosition || 'center'}` }"
      ></div>
      <div class="inner-header-nav">
        <template v-for="(l, i) in links">
          <router-link
            :key="`inner-header-link-${i}`"
            exact-active-class="inner-header-link-active"
            class="text-light"
            :class="{'inner-header-link-active': checkForActive(l) }"
            :to="l.url"
          >
            {{ l.name }}
            <span
              v-if="i < links.length - 1"
              :key="`line-${i}`"
              class="kcm text-light v-line"
            ></span>
          </router-link>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '../shared/Header';
export default {
  components: {
    Header
  },
  props: ['cover', 'bgColor', 'links', 'bgPosition', 'fixedOnly', 'backTo'],
  data() {
    return {
      small: this.fixedOnly || false,
      fixed: this.fixedOnly || false
    };
  },
  watch: {
    fixedOnly(to) {
      if (!to) {
        this.startListening();
      } else {
        this.stopListening();
      }
    }
  },
  methods: {
    goToHome() {
      this.$router.push('/');
    },
    toggleScroll() {
      if (this.fixedOnly) {
        this.$router.push({ path: this.backTo });
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    },
    handleScroll() {
      if (window.pageYOffset > 0) {
        this.fixed = true;
      } else {
        this.fixed = false;
      }
    },
    startListening() {
      setTimeout(() => {
        this.small = true;
      }, 600);
      this.fixed = false;
      document.addEventListener('scroll', this.handleScroll);
    },
    stopListening() {
      this.fixed = true;
      document.removeEventListener('scroll', this.handleScroll);
    },
    checkForActive(l) {
      if (l.active) {
        if (l.active.indexOf(this.$route.fullPath) > -1) {
          return true;
        }
      }
      return false;
    }
  },
  mounted() {
    this.$store.dispatch('dark_header', false);
    if (!this.fixedOnly) {
      this.startListening();
    }
  },
  destroyed() {
    this.stopListening();
  }
};
</script>

<style lang="scss" scoped>
.inner-header {
  height: 100vh;
  overflow: hidden;
  padding-top: 100vh;
  position: relative;
  width: calc(100%);
  z-index: 1;
  @include transition(all 1s $mainCubic);
  // EDGE FIX
  left: 0px;
  right: 0px;
  top: 0px;
  .inner-header-nav-wrapper {
    height: 100vh;
    left: 0px;
    position: fixed;
    top: 0px;
    right: 0px;
    @include transition(all 1s $mainCubic);
    width: calc(100%);
    z-index: 1;
  }
  .inner-header-nav-bg,
  .inner-header-nav-img {
    background-size: cover;
    height: 100%;
    left: 0px;
    right: 0px;
    opacity: 0;
    position: absolute;
    top: 0px;
    @include transition(all 1s $mainCubic);
    width: calc(100%);
    z-index: 1;
  }
  .inner-header-nav-img {
    opacity: 1;
    z-index: 0;
  }
  .inner-header-nav {
    @include transform(translateY(-100vh));
    opacity: 0;
    @include transition(all 1s $mainCubic);
  }
}
.inner-header-small {
  height: 257px;
  padding-top: 257px;
  .inner-header-nav-wrapper {
    height: 257px;
    @extend %flex-center;
    align-items: flex-end;
    width: calc(100%);
    .inner-header-nav-bg {
      opacity: 0.7;
    }
    .inner-header-nav {
      @extend %flex-center;
      padding: 2px 0;
      opacity: 1;
      @include transform(translateY(0));
      z-index: 10;
      a {
        @extend %flex-center;
        font-size: 13px;
        font-weight: 500;
        height: 44px;
        margin: 0 10px;
        padding: 0 15px;
        position: relative;
        text-transform: uppercase;
        @include transition(all 0.3s);
        .v-line {
          background-color: #c9ced2;
          width: 2px;
          height: 80%;
          opacity: 0.5;
          font-size: 30px;
          position: absolute;
          right: -10px;
          top: 10%;
          transform: skewX(25deg);
        }
      }
      a::before {
        border-color: $mainTextLight transparent transparent transparent;
        border-style: solid;
        border-width: 44px 0 0 20px;
        content: '';
        height: 0px;
        left: -20px;
        opacity: 0;
        top: 0px;
        position: absolute;
        @include transition(all 0.3s);
        width: 0px;
      }
      a::after {
        border-color: transparent transparent $mainTextLight transparent;
        border-style: solid;
        border-width: 0 20px 44px 0;
        content: '';
        height: 0px;
        right: -20px;
        opacity: 0;
        top: 0px;
        position: absolute;
        @include transition(all 0.3s);
        width: 0px;
      }
      .inner-header-link-active,
      a:hover {
        background-color: $mainTextLight;
        color: $mainText;
      }
      .inner-header-link-active::before,
      .inner-header-link-active::after,
      a:hover::before,
      a:hover::after {
        opacity: 1;
      }
    }
  }
  .logo-small,
  .scroll-top {
    cursor: pointer;
    font-size: 18px;
    padding: 10px;
    position: absolute;
    right: 6px;
    top: 50%;
    transform: translateY(-50%);
    @include transition(all 0.3s);
    z-index: 2;
  }
  .scroll-top:hover {
    background-color: rgba(255, 255, 255, 0.1);
    opacity: 0.8;
  }
  .logo-small {
    height: 100%;
    left: 6px;
    right: initial;
  }
  .logo-small:hover {
    opacity: 0.8;
  }
  .empty-span {
    height: 0.01px;
    left: -9999px;
    position: absolute;
    top: -9999px;
    z-index: -1;
    width: 0.01px;
  }
}
.inner-header-fixed {
  background-image: none !important;
  height: 48px;
  left: 0px;
  right: 0px;
  padding-top: 48px;
  top: 0px;
  width: calc(100%);
  z-index: 10;
  .inner-header-nav-wrapper {
    height: 48px;
    left: $sidesPadding;
    right: $sidesPadding;
    top: 10px;
    width: calc(100% - 240px);
  }
  .inner-header-nav-bg {
    opacity: 0.95 !important;
  }
  .inner-header-nav-img {
    opacity: 0;
  }
  .inner-header-nav {
    align-items: center;
  }
}
.inner-header-fixed-only {
  height: 0;
  padding-top: 0;
}

@media screen and (max-width: 1600px) {
  .inner-header-small {
    .inner-header-nav-wrapper {
      .inner-header-nav {
        a {
          padding: 0 8px;
          font-size: 12px;
        }
      }
    }
  }
  .inner-header-fixed {
    .inner-header-nav-wrapper {
      width: calc(100% - 200px);
      left: $sidesPadding1600;
      right: $sidesPadding1600;
    }
  }
}
@media screen and (max-width: 1440px) {
  .inner-header-small {
    .inner-header-nav-wrapper {
      .inner-header-nav {
        a {
          padding: 0 4px;
          font-size: 11px;
        }
      }
    }
  }
}
@media screen and (max-width: 1280px) {
  .inner-header {
    .inner-header-nav-wrapper {
      .inner-header-nav {
        display: none;
      }
    }
  }
  .inner-header-small {
    .logo-small,
    .scroll-top {
      display: none;
    }
  }
  .inner-header-fixed {
    // position: static;
    width: 100%;
    height: 257px;
    z-index: 0;

    .inner-header-nav-wrapper {
      height: 257px;
      position: static;
      left: 0px;
      right: 0px;
      top: 0px;
      width: 100%;
      .inner-header-nav-bg {
        opacity: 0.7 !important;
      }
      .inner-header-nav-img {
        opacity: 1;
      }
    }
  }
  .inner-header-fixed-only {
    display: none;
  }
}

@media screen and (max-width: 600px) {
  .inner-header-fixed {
    .inner-header-nav-wrapper {
      left: 0px;
      right: 0px;
      width: 100%;
    }
  }
}
</style>
